module.exports = __webpack_public_path__ + "static/media/arrow-teal-r.5b564c49.svg";